export default "__VITE_ASSET__739d3673__"